import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
    AlertService,
    AppStateService,
    AuthorDataService,
    AuthorService,
    EventService,
    FormMapperService,
    LoadingService,
    LocalStorage,
    LoggerService,
    ModalService,
    PollUtilService,
    StoreService,
    TakerDataService,
    TakerService,
    TitleService,
    UtilService,
    WebUtilService,
    WorkflowService
} from './services';
import {AdminDataService} from "./services/admin/adminData.service";

/**
 * Do not specify providers for modules that might be imported by a lazy loaded module.
 */

@NgModule({

    imports: [CommonModule],

    declarations: [],

    exports: []
})
export class HbsServicesModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: HbsServicesModule,
            providers: [
                ModalService, AlertService, LoadingService, LoggerService,
                TitleService, UtilService, WebUtilService, EventService,

                AdminDataService,
                AuthorDataService, AuthorService,
                TakerDataService, TakerService,
                AppStateService, WorkflowService, StoreService,
                PollUtilService, WebUtilService,
                LocalStorage,
                FormMapperService

            ]
        };
    }
}
